module.exports = __webpack_public_path__ + "img/T1A_xh_20.4fe77d02.png";